import { useState } from "react";

export async function copyTextToClipboard(text) {
  if ("clipboard" in navigator) {
    return await navigator.clipboard.writeText(text);
  } else {
    return document.execCommand("copy", true, text);
  }
}

export const useClipboard = (): [boolean, (text: string) => Promise<void>] => {
  const [copied, setCopied] = useState(false);

  const copyText = async (text) => {
    await copyTextToClipboard(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return [copied, copyText];
};
